<div class="page">
  <div class="content">
    <app-header class="header"></app-header>
    <router-outlet></router-outlet>
  </div>
  <app-footer class="footer"></app-footer>
</div>
<ngx-ui-loader></ngx-ui-loader>
